import {ThemeIconKey} from 'platform/foundation';
import {match} from 'ts-pattern';

import {isNil} from 'ramda';

import {TestIdProps} from 'shared/web';

import {Alert} from '../../../../../components/Alert/Alert';
import i18n from '../../../../../i18n/i18n';

interface AttractivenessDynamicsAlertProps extends TestIdProps {
  dynamics?: string;
}

export function AttractivenessDynamicsAlert(props: AttractivenessDynamicsAlertProps) {
  const dynamics = match<
    string | undefined,
    {
      flag: string;
      description: string;
      color: 'success' | 'warning' | 'neutral';
      icon: ThemeIconKey;
    } | null
  >(props.dynamics)
    .with('PRICE_DYNAMICS_FALLING', () => ({
      flag: i18n.t('entity.attractivenessCard.fallingPriceFlag'),
      description: i18n.t('entity.attractivenessCard.fallingPriceDescription'),
      color: 'warning',
      icon: 'action/trending_down',
    }))
    .with('PRICE_DYNAMICS_STABLE', () => ({
      flag: i18n.t('entity.attractivenessCard.stablePriceFlag'),
      description: i18n.t('entity.attractivenessCard.stablePriceDescription'),
      color: 'neutral',
      icon: 'action/info_outline',
    }))
    .with('PRICE_DYNAMICS_RISING', () => ({
      flag: i18n.t('entity.attractivenessCard.risingPriceFlag'),
      description: i18n.t('entity.attractivenessCard.risingPriceDescription'),
      color: 'success',
      icon: 'action/trending_up',
    }))
    .otherwise(() => null);

  if (isNil(dynamics)) {
    return null;
  }

  return (
    <Alert variant={dynamics.color} icon={dynamics.icon} data-testid={props['data-testid']}>
      <strong>{dynamics.flag}</strong>: {dynamics.description}
    </Alert>
  );
}
